import { useState } from 'react';
import { Sparkles, Settings } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../../services/settings.service';
import { LlmIntegrationForm } from './LlmIntegrationForm';

export function LlmIntegrationCard() {
  const [showForm, setShowForm] = useState(false);

  const { data: aiConfig } = useQuery({
    queryKey: ['settings', 'ai'],
    queryFn: () => settingsService.getAi(),
  });

  const configuredCount = (aiConfig?.hasAnthropicKey ? 1 : 0) + (aiConfig?.hasOpenaiKey ? 1 : 0);
  const isConfigured = configuredCount > 0;

  return (
    <>
      <div className="bg-white rounded-xl border border-secondary-200 p-5 hover:shadow-sm transition-shadow">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3">
            <div
              className={`w-2.5 h-2.5 rounded-full ${
                isConfigured ? 'bg-green-500' : 'bg-secondary-300'
              }`}
            />
            <div>
              <h3 className="font-semibold text-secondary-900">Modelos de IA</h3>
              <p className="text-xs text-secondary-500">
                Chaves de Anthropic e OpenAI, cifradas no banco
              </p>
            </div>
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={() => setShowForm(true)}
              className="p-2 rounded-lg hover:bg-secondary-100 text-secondary-500"
            >
              <Settings className="w-4 h-4" />
            </button>
          </div>
        </div>

        {isConfigured ? (
          <div className="text-sm text-secondary-600 space-y-1">
            <p>Anthropic: {aiConfig?.hasAnthropicKey ? 'configurada' : 'não configurada'}</p>
            <p>OpenAI: {aiConfig?.hasOpenaiKey ? 'configurada' : 'não configurada'}</p>
            <p className="text-xs text-secondary-400">
              Modelo padrão: <span className="font-mono">{aiConfig?.defaultModel}</span>
            </p>
          </div>
        ) : (
          <div className="flex items-center gap-2 mt-2 text-sm text-secondary-400">
            <Sparkles className="w-4 h-4" />
            <span>Nenhuma chave configurada — clique na engrenagem para conectar</span>
          </div>
        )}
      </div>

      {showForm && <LlmIntegrationForm onClose={() => setShowForm(false)} />}
    </>
  );
}
